import Component from '../core/Component'
import ScrollService from '../services/Scroll'
import { EVENTS } from '../core/Events'
import EventBus from '../core/EventBus'

const STATES = {
    ACTIVE: 'is-active',
}

export default class Header extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            hamburger: null,
            navigation: null,
            reservationButton: null
        }

        this.state = {
            status: false
        }

        this.navigationLinks = null
        this.roomDetail = false
    }

    prepare() {
        EventBus.on(EVENTS.SWUP_CONTENT_REPLACED, this.handlePageChange)
        EventBus.on(EVENTS.SWUP_CONTENT_REPLACED, this.handleActiveLinks)
        EventBus.on(EVENTS.HEADER_OPENNAVIGATION, this.openNavigation)
        EventBus.on(EVENTS.SWUP_CLICK_LINK, this.handleSwupLinkClick)
        ScrollService.on('scroll', this.handleScroll)

        this.ref.hamburger.addEventListener('click', this.handleNavState)

        this.navigationLinks = this.ref.navigation.querySelectorAll('a')
        this.handleActiveLinks()
        this.handleClickedLink()

        if(document.querySelector('.roomDetail-Page')) {
            this.roomDetail = true
        } else {
            this.roomDetail = false
        }
    }

    destroy() {
        EventBus.off(EVENTS.SWUP_CONTENT_REPLACED, this.handlePageChange)
        EventBus.off(EVENTS.SWUP_CONTENT_REPLACED, this.handleActiveLinks)
        EventBus.off(EVENTS.HEADER_OPENNAVIGATION, this.openNavigation)
        EventBus.off(EVENTS.SWUP_CLICK_LINK, this.handleSwupLinkClick)
        ScrollService.off('scroll', this.handleScroll)
    }

    handleSwupLinkClick = () => {
        this.navigationLinks.forEach(link => {
            link.parentNode.classList.remove('is-active')
            this.closeNavigation()
        })
    }

    handleScroll = ({ y }) => {
        if(window.innerWidth > 1023) {
            this.render(y)
        }
    }

    handlePageChange = () => {
        if(document.querySelector('.roomDetail-Page')) {
            this.roomDetail = true
            this.ref.reservationButton.style.transform = `translateY(0px)`
        } else {
            this.roomDetail = false
        }
    }

    handleActiveLinks = () => {
        this.navigationLinks.forEach(item => {
            item.parentNode.classList.remove('is-active')
            if(window.location.href.includes(item.getAttribute('href'))) {
                item.parentNode.classList.add('is-active')
            }
        })
    }

    handleClickedLink = () => {
        this.navigationLinks.forEach(item => {
            item.addEventListener('click', event => {
                setTimeout(() => {
                    event.target.closest('li').classList.add('is-active')

                }, 100)
            })
        })
    }

    render(y) {
        this.element.style.transform = `translateY(${-y}px)`
        if(!this.roomDetail) {
            this.ref.reservationButton.style.transform = `translateY(${y}px)`
        }
    }

    handleNavState = () => {
        if(this.state.status) {
            this.closeNavigation()
        } else {
            this.openNavigation()
        }
    }

    openNavigation = () => {
        this.state.status = true
        this.ref.hamburger.classList.add(STATES.ACTIVE)
        this.ref.navigation.classList.add(STATES.ACTIVE)
    }

    closeNavigation = () => {
        this.state.status = false
        this.ref.hamburger.classList.remove(STATES.ACTIVE)
        this.ref.navigation.classList.remove(STATES.ACTIVE)
    }
}
